<template>
  <ContentWrap>
    <el-form :model="query" inline>
      <el-form-item label="认证对象"
        ><BusinessLookupSelect v-model="query.certificationId" type="certifications" placeholder="请选择认证对象"
      /></el-form-item>
      <el-form-item label="凭证类型"
        ><el-input v-model="query.credentialType" clearable
      /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" clearable class="!w-130px">
          <el-option
            v-for="(label, value) in statusLabels"
            :key="value"
            :label="label"
            :value="Number(value)"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="timeRange"
          type="datetimerange"
          value-format="YYYY-MM-DD HH:mm:ss"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="requestNo" label="请求号" min-width="160" />
      <el-table-column label="认证对象" min-width="140"><template #default="scope"><BusinessLookupName type="certifications" :id="scope.row.certificationId" /></template></el-table-column>
      <el-table-column prop="credentialType" label="凭证类型" width="120" />
      <el-table-column prop="chainNetwork" label="链网络" width="120" />
      <el-table-column prop="chainTxId" label="交易ID" min-width="180" show-overflow-tooltip />
      <el-table-column label="状态" width="100"
        ><template #default="scope">{{ statusLabels[scope.row.status] }}</template></el-table-column
      >
      <el-table-column label="操作" width="190">
        <template #default="scope">
          <el-button link type="primary" @click="openDetail(scope.row.id)">详情</el-button>
          <el-button
            v-hasPermi="['bosscircle:cert-proof:verify']"
            link
            type="success"
            @click="verify(scope.row.id)"
            >核验</el-button
          >
          <el-button
            v-if="scope.row.status === 2 && scope.row.currentFlag"
            v-hasPermi="['bosscircle:cert-proof:revoke']"
            link
            type="danger"
            @click="revoke(scope.row)"
            >撤销</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <Pagination
      v-model:page="query.pageNo"
      v-model:limit="query.pageSize"
      :total="total"
      @pagination="load"
    />
  </ContentWrap>

  <Dialog v-model="detailVisible" title="认证存证详情" width="820px">
    <el-descriptions v-if="detail" :column="2" border>
      <el-descriptions-item label="请求号">{{ detail.requestNo }}</el-descriptions-item>
      <el-descriptions-item label="尝试次数">{{ detail.attemptNo }}</el-descriptions-item>
      <el-descriptions-item label="认证记录">{{ detail.certificationId }}</el-descriptions-item>
      <el-descriptions-item label="凭证类型">{{ detail.credentialType }}</el-descriptions-item>
      <el-descriptions-item label="凭证哈希" :span="2">{{
        detail.credentialHash
      }}</el-descriptions-item>
      <el-descriptions-item label="链网络">{{ detail.chainNetwork || '-' }}</el-descriptions-item>
      <el-descriptions-item label="当前有效">{{
        detail.currentFlag ? '是' : '否'
      }}</el-descriptions-item>
      <el-descriptions-item label="交易ID" :span="2">{{
        detail.chainTxId || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="凭证地址" :span="2">
        <el-link v-if="detail.proofUrl" :href="detail.proofUrl" target="_blank" type="primary">{{
          detail.proofUrl
        }}</el-link
        ><span v-else>-</span>
      </el-descriptions-item>
      <el-descriptions-item label="失败摘要" :span="2">{{
        detail.errorMessage || '-'
      }}</el-descriptions-item>
      <el-descriptions-item label="确认时间">{{ detail.confirmedAt || '-' }}</el-descriptions-item>
      <el-descriptions-item label="撤销时间">{{ detail.revokedAt || '-' }}</el-descriptions-item>
    </el-descriptions>
  </Dialog>
</template>

<script setup lang="ts">
import * as CertProofApi from '@/api/business/certProof'

defineOptions({ name: 'BossCircleCertProof' })
const message = useMessage()
const loading = ref(false)
const list = ref<any[]>([])
const total = ref(0)
const timeRange = ref<string[]>([])
const detailVisible = ref(false)
const detail = ref<any>()
const statusLabels: Record<number, string> = {
  0: '待存证',
  1: '处理中',
  2: '成功',
  3: '失败',
  4: '已撤销'
}
const query = reactive({
  pageNo: 1,
  pageSize: 10,
  certificationId: undefined,
  credentialType: '',
  status: undefined
})
const load = async () => {
  loading.value = true
  try {
    const data = await CertProofApi.getCertProofPage({
      ...query,
      beginTime: timeRange.value?.[0],
      endTime: timeRange.value?.[1]
    })
    list.value = data.list || []
    total.value = data.total || 0
  } finally {
    loading.value = false
  }
}
const search = () => {
  query.pageNo = 1
  load()
}
const openDetail = async (id: number) => {
  detail.value = await CertProofApi.getCertProof(id)
  detailVisible.value = true
}
const verify = async (id: number) => {
  const result = await CertProofApi.verifyCertProof(id)
  result.valid ? message.success(result.message) : message.warning(result.message)
}
const revoke = async (row: any) => {
  await message.confirm('确认撤销该有效存证吗？')
  await CertProofApi.revokeCertProof({ id: row.id, version: row.version })
  message.success('撤销成功')
  await load()
}
onMounted(load)
</script>
